var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'sidebar',
    { collapsible: _vm.collapsible, collapsed: _vm.isSidebarCollapsed },
    _vm.type ]},[(_vm.collapsible)?_c('div',{staticClass:"collapse-wrapper",on:{"click":_vm.collapse}},[(!_vm.isSidebarCollapsed)?_c('img',{staticClass:"icon-collapse",attrs:{"src":require("@assets/images/icon-arrows-collapse.svg")}}):_c('img',{staticClass:"icon-collapse",attrs:{"src":require("@assets/images/icon-arrows-expand.svg")}})]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }